import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  cookingStoryKitchenSearchResponce,
  createKitchenItem,
  createKitchenResponce,
  createshoppingListItem,
  createshoppingListResponce,
  getHomeMembers,
  groceryCategoryRespoce,
  KitchenHomeItemResponce,
  kitchenSuggestion,
  shoppingListHomeItemResponce,
} from 'src/app/core/model/api-response/cooking-story-model';
import { baseUrl } from 'src/app/global-variables';
import { WebengageService } from '../analytics-repository/webengage.service';
import {
  BaseResponse,
  GenericResponse,
  GenericResponseData,
} from '../generic-response';
import { IndexdbLastupdateService } from '../indexdb-lastupdate/indexdb-lastupdate.service';
import { UserDataService } from '../user-repository/user-data.service';

@Injectable({
  providedIn: 'root',
})
export class CookingStoryGroceryApiService {
  constructor(
    private http: HttpClient,
    private userDataService: UserDataService,
    private IndexdbLastupdateService: IndexdbLastupdateService,
    private webengage: WebengageService
  ) {}
  getKitchenMostUse(): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .get<KitchenHomeItemResponce>(baseUrl + 'api/v2/kitchen/mostUsed', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        if (result.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({
              KitchenHomeItemResponce: result,
            })
          );
        }
      });
  }
  getShoppingListMostUse(): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .get<shoppingListHomeItemResponce>(
        baseUrl + 'api/v2/shoppingList/mostUsed',
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        if (result.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({
              shoppingListHomeItemResponce: result,
            })
          );
        }
      });
  }
  getKitchenSearch(q: string): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .get<cookingStoryKitchenSearchResponce>(
        baseUrl + 'api/v2/grocerycategory/food/search?text=' + q,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        if (result.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({
              cookingStoryKitchenResponce: result,
            })
          );
        }
      });
  }
  getKitchenHomeItem(): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .get<KitchenHomeItemResponce>(baseUrl + 'api/v2/kitchen', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        if (result.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({
              KitchenHomeItemResponce: result,
            })
          );
        }
      });
  }
  getGroceryCategoryList() {
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .get<groceryCategoryRespoce>(baseUrl + 'api/v2/grocerycategory/list', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        if (result.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({
              groceryCategoryRespoce: result,
            })
          );
        }
      });
  }
  saveKitchenItems(data: createKitchenItem[]) {
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .post<createKitchenResponce>(baseUrl + 'api/v2/kitchen', data, {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        if (result.success) {
          this.webengage.kitchen_item_added();
          this.IndexdbLastupdateService.setCookingStoryItem(0);
          return new GenericResponse(
            true,
            new GenericResponseData({
              createKitchenResponce: result,
            })
          );
        }
      });
  }
  updateKitchenItem(id: string, data: createKitchenItem) {
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .put<BaseResponse>(baseUrl + 'api/v2/kitchen/' + id, data, {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        if (result.success) {
          this.IndexdbLastupdateService.setCookingStoryItem(0);

          return new GenericResponse(
            true,
            new GenericResponseData({
              BaseResponse: result,
            })
          );
        }
      });
  }
  updateShoppingListItem(id: string, data: createshoppingListItem) {
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .put<BaseResponse>(baseUrl + 'api/v2/shoppingList/' + id, data, {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        if (result.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({
              BaseResponse: result,
            })
          );
        }
      });
  }
  saveShoppingListItems(data: createshoppingListItem[]) {
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .post<createshoppingListResponce>(baseUrl + 'api/v2/shoppingList', data, {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        if (result.success) {
          this.webengage.shopping_item_added();
          return new GenericResponse(
            true,
            new GenericResponseData({
              createShoppingListResponce: result,
            })
          );
        }
      });
  }
  getShoppingListHomeItem(): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .get<shoppingListHomeItemResponce>(baseUrl + 'api/v2/shoppingList', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        if (result.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({
              shoppingListHomeItemResponce: result,
            })
          );
        }
      });
  }
  deleteShoppingList(ids: string[]): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    const options = {
      headers: new HttpHeaders(headerDict),
      body: ids,
    };
    return this.http
      .delete<BaseResponse>(baseUrl + 'api/v2/shoppingList', options)
      .toPromise()
      .then(async (res) => {
        return new GenericResponse(
          res.success,
          new GenericResponseData({ BaseResponse: res })
        );
      });
  }
  deleteKitchenItem(ids: string[]): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    const options = {
      headers: new HttpHeaders(headerDict),
      body: ids,
    };

    return this.http
      .delete<BaseResponse>(baseUrl + 'api/v2/kitchen', options)
      .toPromise()
      .then(async (res) => {
        this.IndexdbLastupdateService.setCookingStoryItem(0);

        return new GenericResponse(
          res.success,
          new GenericResponseData({ BaseResponse: res })
        );
      });
  }
  getHomeMembers(id?: string) {
    const headerDict = this.userDataService.getHeaderDict();
    id = id ? '/' + id : '';
    return this.http
      .get<getHomeMembers>(baseUrl + 'api/v2/home' + id, {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        this.IndexdbLastupdateService.setCookingStoryItem(0);

        return new GenericResponse(
          true,
          new GenericResponseData({
            getHomeMembers: result,
          })
        );
      });
  }
  joinUserToHome(userId: string, homeId: string) {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .post<getHomeMembers>(
        baseUrl + 'api/v2/home',
        { homeId, userId },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        this.IndexdbLastupdateService.setCookingStoryItem(0);

        return new GenericResponse(
          true,
          new GenericResponseData({
            getHomeMembers: result,
          })
        );
      });
  }
  leaveFromHome() {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .delete<BaseResponse>(baseUrl + '/api/v2/home/leave', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then(async (res) => {
        this.IndexdbLastupdateService.setCookingStoryItem(0);

        return new GenericResponse(
          res.success,
          new GenericResponseData({ BaseResponse: res })
        );
      });
  }
  kickUser(id: string) {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    const options = {
      headers: new HttpHeaders(headerDict),
      body: {
        userId: id,
      },
    };
    return this.http
      .delete<BaseResponse>(baseUrl + '/api/v2/home/remove', options)
      .toPromise()
      .then(async (res) => {
        this.IndexdbLastupdateService.setCookingStoryItem(0);

        return new GenericResponse(
          res.success,
          new GenericResponseData({ BaseResponse: res })
        );
      });
  }
  getkitchenSuggestion() {
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .get<kitchenSuggestion>(baseUrl + 'api/v2/recipe/kitchenSuggestion', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        if (result.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({
              kitchenSuggestion: result,
            })
          );
        }
      });
  }
}
